// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Settings page — INCYIA form kit extensions */

/* Equal tiles: 4 across. Global \`button { width: fit-content !important }\` must be overridden. */
.incyia-settings-norm-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  width: 100%;
}

.incyia-settings-norm-card {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
  height: 64px;
  width: 100% !important;
  max-width: none !important;
  min-width: 0;
  margin: 0;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1.5px solid #dfe7e8;
  background: #fff;
  cursor: pointer;
  text-align: left;
  font-family: Lato, sans-serif;
  box-sizing: border-box;
  transition: border-color 0.14s, background 0.14s, box-shadow 0.14s;
}

.incyia-settings-norm-card:hover {
  border-color: #8a9ba7;
  background: #fafcfc;
}

.incyia-settings-norm-card.is-active {
  border-color: #0d9b87;
  background: #f2faf8;
  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.12);
}

.incyia-settings-norm-card-mark {
  width: 16px;
  height: 16px;
  margin-top: 2px;
  border-radius: 50%;
  border: 1.5px solid #c5d0d4;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  transition: border-color 0.14s, background 0.14s;
}

.incyia-settings-norm-card.is-active .incyia-settings-norm-card-mark {
  border-color: #0d9b87;
  background: #0d9b87;
  color: #fff;
}

.incyia-settings-norm-card-mark svg {
  opacity: 0;
}

.incyia-settings-norm-card.is-active .incyia-settings-norm-card-mark svg {
  opacity: 1;
}

.incyia-settings-norm-card-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1;
}

.incyia-settings-norm-card-label {
  font-size: 13px;
  font-weight: 700;
  color: #0b1e2d;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.incyia-settings-norm-card-hint {
  font-size: 11px;
  color: #8a9ba7;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.incyia-settings-summary {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.incyia-settings-summary-row {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.incyia-settings-summary-row + .incyia-settings-summary-row {
  padding-top: 10px;
  border-top: 1px solid #eaf0f0;
}

.incyia-settings-summary-k {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #8a9ba7;
  font-family: Lato, sans-serif;
}

.incyia-settings-summary-v {
  font-size: 13px;
  font-weight: 600;
  color: #0b1e2d;
  font-family: Lato, sans-serif;
  word-break: break-word;
}

.incyia-settings-summary-empty {
  color: #8a9ba7;
  font-weight: 500;
}

.incyia-settings-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 2px;
}

.incyia-settings-chip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 9px;
  border-radius: 999px;
  background: #e1f4f0;
  color: #076b5c;
  font-size: 11px;
  font-weight: 700;
  font-family: Lato, sans-serif;
}

.incyia-settings-status {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  font-size: 12px;
  color: #5f7484;
}

.incyia-settings-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #c5d0d4;
  flex-shrink: 0;
}

.incyia-settings-status-dot.is-ready {
  background: #0d9b87;
}

.incyia-settings-status-dot.is-dirty {
  background: #e6a817;
}

.incyia-settings-tour-btn {
  width: 100% !important;
  margin-top: 4px;
  justify-content: center;
}

.incyia-settings-aside-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

@media (max-width: 1100px) {
  .incyia-settings-norm-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .incyia-settings-norm-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/settings/Settings.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C,iGAAiG;AACjG;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF","sourcesContent":["/* Settings page — INCYIA form kit extensions */\n\n/* Equal tiles: 4 across. Global `button { width: fit-content !important }` must be overridden. */\n.incyia-settings-norm-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 8px;\n  width: 100%;\n}\n\n.incyia-settings-norm-card {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 10px;\n  height: 64px;\n  width: 100% !important;\n  max-width: none !important;\n  min-width: 0;\n  margin: 0;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1.5px solid #dfe7e8;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n  font-family: Lato, sans-serif;\n  box-sizing: border-box;\n  transition: border-color 0.14s, background 0.14s, box-shadow 0.14s;\n}\n\n.incyia-settings-norm-card:hover {\n  border-color: #8a9ba7;\n  background: #fafcfc;\n}\n\n.incyia-settings-norm-card.is-active {\n  border-color: #0d9b87;\n  background: #f2faf8;\n  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.12);\n}\n\n.incyia-settings-norm-card-mark {\n  width: 16px;\n  height: 16px;\n  margin-top: 2px;\n  border-radius: 50%;\n  border: 1.5px solid #c5d0d4;\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  transition: border-color 0.14s, background 0.14s;\n}\n\n.incyia-settings-norm-card.is-active .incyia-settings-norm-card-mark {\n  border-color: #0d9b87;\n  background: #0d9b87;\n  color: #fff;\n}\n\n.incyia-settings-norm-card-mark svg {\n  opacity: 0;\n}\n\n.incyia-settings-norm-card.is-active .incyia-settings-norm-card-mark svg {\n  opacity: 1;\n}\n\n.incyia-settings-norm-card-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n}\n\n.incyia-settings-norm-card-label {\n  font-size: 13px;\n  font-weight: 700;\n  color: #0b1e2d;\n  line-height: 1.25;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.incyia-settings-norm-card-hint {\n  font-size: 11px;\n  color: #8a9ba7;\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.incyia-settings-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.incyia-settings-summary-row {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.incyia-settings-summary-row + .incyia-settings-summary-row {\n  padding-top: 10px;\n  border-top: 1px solid #eaf0f0;\n}\n\n.incyia-settings-summary-k {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #8a9ba7;\n  font-family: Lato, sans-serif;\n}\n\n.incyia-settings-summary-v {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0b1e2d;\n  font-family: Lato, sans-serif;\n  word-break: break-word;\n}\n\n.incyia-settings-summary-empty {\n  color: #8a9ba7;\n  font-weight: 500;\n}\n\n.incyia-settings-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 2px;\n}\n\n.incyia-settings-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 9px;\n  border-radius: 999px;\n  background: #e1f4f0;\n  color: #076b5c;\n  font-size: 11px;\n  font-weight: 700;\n  font-family: Lato, sans-serif;\n}\n\n.incyia-settings-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 4px;\n  font-size: 12px;\n  color: #5f7484;\n}\n\n.incyia-settings-status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #c5d0d4;\n  flex-shrink: 0;\n}\n\n.incyia-settings-status-dot.is-ready {\n  background: #0d9b87;\n}\n\n.incyia-settings-status-dot.is-dirty {\n  background: #e6a817;\n}\n\n.incyia-settings-tour-btn {\n  width: 100% !important;\n  margin-top: 4px;\n  justify-content: center;\n}\n\n.incyia-settings-aside-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n@media (max-width: 1100px) {\n  .incyia-settings-norm-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 640px) {\n  .incyia-settings-norm-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
